export default __webpack_public_path__ + "static/media/yellow-orange.41f32732.png";